import CouponPattern from 'assets/Footer/CouponPatternI';
import Link from 'next/link';
import React from 'react';
import { BiChevronRight } from 'react-icons/bi';

import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';

const ContactSection = () => {
  return (
    <div className='flex justify-center mt-7'>
      <Link
        target='_blank'
        className='flex flex-1'
        href="https://go.zebralearn.com/inquiry-form"
      >
        <div className='flex flex-1'>
          <CouponPattern className='h-full' />
          <div className='flex-1 relative bg-orangeZl-950 xl:px-[50px] md:px-[25px] px-3 xl:py-7 md:py-3.5 py-3 flex md:flex-row flex-col md:items-center items-start justify-between md:gap-10 gap-2.5'>
            <p className='font-semibold xl:text-2xl md:text-lg text-sm text-white flex-1 max-w-[900px]'>
              Unlock exclusive discounts on bulk orders and equip your entire
              team or institution with high-quality learning tools from
              ZebraLearn.
            </p>
            <ButtonDefault
              className='md:py-2.5 py-1.5 md:px-5 px-1.5'
              size={0}
              variant={ButtonVariants.WHITE}
            >
              <div className='flex gap-2 items-center flex-nowrap'>
                <p className='text-grayzl-950 md:text-sm text-xs font-semibold'>
                  Contact Us
                </p>
                <BiChevronRight className='text-grayzl-950 md:w-[22px] w-[20px] md:h-[22px] h-[20px]' />
              </div>
            </ButtonDefault>
          </div>
          <CouponPattern className='scale-x-[-1] h-full' />
        </div>
      </Link>
    </div>
  );
};

export default ContactSection;
